import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { Permission } from 'core/api';
import { AppointmentFacade } from 'pos/facades';

declare global {
	interface CommandType {
		deleteAppointment: (id: number) => Promise<Result>
	}
}

Command.register('deleteAppointment', Preconditions.and(Preconditions.ensure(Permission.Appointment_Delete), Preconditions.ensureIsNotLite), async (id: number): Promise<Result> => {
	await AppointmentFacade.remove(id);
	return Result.ok();
});
